'use client'

import { sendErrorLog } from "@/utils/http";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { usePathname, useRouter } from "next/navigation";
import { useEffect, useState } from "react";

export default function GlobalError({error, reset}) {
    const [errorCode, setErrorCode] = useState("");
    const path = usePathname();
    const router = useRouter();
    const queryClient = useQueryClient();
    const [userAgent, setUserAgent] = useState("");

    useEffect(() => {
        setUserAgent(navigator.userAgent);
    }, []);

    const { mutate: sendError } = useMutation({
        mutationFn: sendErrorLog,
        onSuccess: (response, params) => {
            if(response.success) {
                setErrorCode(response.response.code);
            }
        },
        onError: (error) => {
            // Ha a hibaküldés is sikertelen, generáljunk helyi hibakódot
            console.error("Hibaküldés sikertelen:", error);
            setErrorCode("LOCAL-" + Date.now().toString().slice(-6));
        }
    });
    
    useEffect(() => {
        if (error) {
            sendErrorLog({
                params: {
                    message: error.message,
                    stack: error.stack,
                    url: path,
                    useragent: navigator.userAgent
                }
            }).catch(err => {
                console.error("Közvetlen hibaküldés sikertelen:", err);
            });
        }
    }, [error, path]);

    useEffect(() => {
        let to_send = {
            message: error.message,
            stack: error.stack,
            url: path,
            useragent: userAgent
        }

        // Logoljuk a hibaküldés tartalmát konzolra
        console.log("Hibaküldés a backendnek:", to_send);

        if(process.env.NEXT_PUBLIC_DISABLE_ERROR_LOG === "enabled") sendError({params: to_send})
    }, [error.message, error.stack, path, userAgent, sendError])

    const handleBackToHome = () => {
        // React Query cache törlése
        queryClient.clear();
        // Vissza a főoldalra
        router.push('/');
    };

    const handleReload = () => {
        // Cache törlés + újratöltés
        queryClient.clear();
        window.location.reload();
    };

    return (<div className="w-100 vh-100 d-flex flex-column gap-3 align-items-center justify-content-center px-3">
        <h2>Hiba történt az oldal betöltésekor</h2>
        <p className="text-muted">Hivatkozási kód: <span className="color-error-500 fw-bold">{errorCode}</span></p>
        
        <div className="d-flex gap-3 flex-wrap justify-content-center">
            <button onClick={handleBackToHome} className="btn btn-primary">
                Vissza a főoldalra
            </button>
            <button onClick={handleReload} className="btn btn-outline-secondary">
                Oldal újratöltése
            </button>
        </div>
        
        <p className="text-muted mt-3 small text-center" style={{maxWidth: '500px'}}>
            Ha a probléma továbbra is fennáll, próbáld meg újratölteni az oldalt 
            <strong> Ctrl+Shift+R</strong> (Windows/Linux) vagy 
            <strong> Cmd+Shift+R</strong> (Mac) billentyűkombinációval.
        </p>
    </div>)
}